export interface PolicyTextSegment {
  text: string;
  href?: string;
}

export interface PolicySubsection {
  heading: string;
  paragraphs?: string[];
  richParagraphs?: PolicyTextSegment[][];
  bullets?: string[];
}

export interface PolicySection {
  id: string;
  title: string;
  subsections: PolicySubsection[];
}

export const policySections: PolicySection[] = [
  {
    id: 'shipping',
    title: 'Shipping',
    subsections: [
      {
        heading: 'Where to buy today',
        paragraphs: [
          'STL files are sold on our marketplace partners, not from this website. Delivery is digital through those platforms.',
        ],
      },
      {
        heading: 'Painted pieces',
        paragraphs: [
          'Online sales and postage for hand-painted pieces are not live yet. When they are, we will ship within Australia first. International options may follow.',
        ],
      },
      {
        heading: 'Custom work',
        paragraphs: [
          'Commissioned pieces are posted after we agree the design, finish, and timeline. Postage details will be confirmed in our reply.',
        ],
      },
    ],
  },
  {
    id: 'returns',
    title: 'Returns & exchanges',
    subsections: [
      {
        heading: 'Digital files',
        paragraphs: [
          'Refunds and re-downloads follow the marketplace you bought from. We cannot reverse a completed STL download ourselves.',
        ],
      },
      {
        heading: 'Painted pieces (when sales open)',
        paragraphs: [
          'If an item arrives damaged, contact us within 7 days with photos and we will repair, replace, or refund. Change-of-mind returns for painted pieces will be published here before checkout goes live.',
        ],
      },
      {
        heading: 'Custom orders',
        paragraphs: [
          'Bespoke work is made to your brief, so we cannot offer change-of-mind returns once production has started. We will always fix defects in our workmanship.',
        ],
      },
    ],
  },
  {
    id: 'stl-licensing',
    title: 'STL licensing',
    subsections: [
      {
        heading: 'Personal use',
        paragraphs: [
          'Files are for your own prints and display unless the marketplace listing says otherwise.',
        ],
      },
      {
        heading: 'You may',
        bullets: [
          'Print for yourself',
          'Paint and finish your prints',
          'Gift a finished physical piece',
        ],
      },
      {
        heading: 'You may not',
        bullets: [
          'Share, resell, or redistribute the digital files',
          'Upload them to other sites',
          'Sell prints commercially without a separate licence',
        ],
      },
      {
        heading: 'Commercial use',
        richParagraphs: [
          [
            { text: 'Email ' },
            {
              text: 'info@faeforest.com.au',
              href: 'mailto:info@faeforest.com.au',
            },
            { text: ' or use the ' },
            { text: 'contact form', href: '/contact' },
            {
              text: '. Partner marketplace terms apply where they are stricter.',
            },
          ],
        ],
      },
    ],
  },
  {
    id: 'custom-orders',
    title: 'Custom orders',
    subsections: [
      {
        heading: 'How to enquire',
        richParagraphs: [
          [
            { text: 'Use the ' },
            { text: 'Custom Orders', href: '/custom-orders' },
            {
              text: ' page to describe size, finish, budget, and timing.',
            },
          ],
        ],
      },
      {
        heading: 'What happens next',
        paragraphs: [
          'We typically reply within 2 business days. A commission starts only after we confirm scope and price in writing (email).',
        ],
      },
      {
        heading: 'Changes to your brief',
        paragraphs: [
          'Small design changes are fine during sketching. Larger changes after printing or painting may affect price or timing.',
        ],
      },
    ],
  },
];
